module.exports = __webpack_public_path__ + "static/centertable-7d0f4a25a3fcc19ee8b6b12cc53e9e1d.png";